import React from "react";

const Popup = ({ content, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="popup-overlay">
      <div className="popup-content">
        <button className="popup-close" onClick={onClose}>
          &times;
        </button>
        {content}
      </div>
    </div>
  );
};

export default Popup;
